import { AbstractVersion40 } from './abstract-version40';

export abstract class AbstractDiscoverableVersion40 extends AbstractVersion40 {}
